// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DiorBanner_wrapper__tlkAz","diorBackStageWrapper":"DiorBanner_diorBackStageWrapper__4ubYR DiorBanner_wrapper__tlkAz"};